module.exports = __webpack_public_path__ + "img/icon-modalidad.0baf0ce4.svg";